import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { isValidRedirect } from '../lib/auth'
import { ROUTES } from '../lib/constants'
import { useAuth } from '../providers/Auth/Auth'
import { BlankLoadingPage } from './pages/BlankLoadingPage'

type ProtectedRouteProps = {
  children: React.ReactNode
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuth()
  const location = useLocation()

  if (isLoading) {
    return <BlankLoadingPage />
  }

  if (!isAuthenticated) {
    const redirectTo = isValidRedirect(location.pathname)
      ? `${ROUTES.logout}?redirectTo=${encodeURIComponent(location.pathname)}`
      : ROUTES.logout

    return <Navigate to={redirectTo} replace />
  }

  return <>{children}</>
}
